// @ts-check
// Objetos e campos de um módulo cobrado à parte (3.0.0, contrato 10 de atendimento, seção 1.4) com o módulo desligado
// na escola: o Modelo de dados não os mostra nem entre os inativos, porque para a escola sem o módulo a 3.0.0 é a
// 2.0.0. O servidor marca cada objeto e campo do módulo com `moduleKey` no bootstrap.

/**
 * O objeto ou o campo é de um módulo desligado?
 * @param {{ moduleKey?: string | null } | null | undefined} metadata @param {(moduleKey: string) => boolean} isModuleEnabled
 */
export function isHiddenModuleMetadata(metadata, isModuleEnabled) {
  return Boolean(metadata?.moduleKey) && !isModuleEnabled(String(metadata?.moduleKey));
}

/**
 * Só o que a escola tem (sem os objetos ou campos de módulo desligado).
 * @template {{ moduleKey?: string | null }} TMetadata
 * @param {ReadonlyArray<TMetadata>} items @param {(moduleKey: string) => boolean} isModuleEnabled
 * @returns {TMetadata[]}
 */
export function withoutDisabledModuleMetadata(items, isModuleEnabled) {
  return items.filter((item) => !isHiddenModuleMetadata(item, isModuleEnabled));
}
